import React from "react";
import Breadcrumb from "../components/Breadcrumb";
// import NavbarTwo from "../components/NavbarTwo";
// import FooterTwo from "../components/FooterTwo";
import MemberInscription from "../pages/MemberInscription";
import UNFMNavbar from "../pages/ENFM/Navbar/UNFMNavbar";
import Footer from "../pages/ENFM/Footer/Footer";
// import FooterOne from "./FooterOne";

const PartnerShipArea = () => {
  return (
    <>
      <div>
        <UNFMNavbar />
        {/* <Breadcrumb title={"Devenir Membre"} /> */}
        <div className="mt-6" style={{  marginTop: "70px"}}>
        <MemberInscription/>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default PartnerShipArea;
